import React from 'react'

const PositionBannerRight = ({pos, desc}) => {
  return (
    <div className='flex justify-center space-x-8 mt-8'>
        <div className='w-1/2 flex items-center bg-navy font-display text-white'>
            <div className='w-1/2 absolute px-16' style={{ zIndex: 1 }}>
                <h1 className='font-bold text-5xl'> {pos} </h1>
                <h1 className='mt-6 text-base'> {desc} </h1> 
            </div>
              <img src={"/various/masseysshop.webp"} 
              className='opacity-30 w-full h-full object-cover'/> 
        </div>
        <div className='w-1/4 h-1/4'>
          <img src={"/prjimg/ParcelG/ParcelG_1.webp"} 
              className='w-full h-full object-cover aspect-square'/> 
        </div>
    </div>
  )
}

export default PositionBannerRight